<div *ngIf="select_jl_screen">
               <app-map-n2p              
                [inputData]="inputData"
                (OnSelectProceedMap) = "OnSelectProceedMap($event)"
                [show_smp_table]="show_smp_table"
            ></app-map-n2p>
    <!-- <div *ngIf="show_smp_table">
            <app-table                 
                table_title="selectBjl" 
                [inputData]="inputData"
                (appItemEvent)="receiveTableEventStructure($event)" >
            </app-table>
    </div> -->
    <div *ngIf="show_smp_table">
      <div class="form-group row">        
          <div class="form-group col-md-6">
            <label for="ada" class="lable-css">SMP Pit ID:</label>
            <input type="text" id="pit_id" formControlName="pitId" name="pit" placeholder="Enter PIT ID" required (change)="inputOnChange($event)" />
          </div>
          <div class="form-group col-md-6">
            <label for="ada" class="lable-css">BJL ID: </label>
            <input type="text" id="bjl_id" formControlName="bjlId" name="bjl" placeholder="Enter BJL ID" value="{{this.inputData.selected_bjl.bjl_id}}" readonly />
          </div>        
        <button (click)="checkDistance()" style="width: 20%;">Validate</button>
        <br />
        <div *ngIf="show_status">
           <b>Pit Fitness check :</b> {{ pit_validation.pit_status }} <br />
           <b>Pit distance :</b> {{ pit_validation.pit_distance }} <br />
           <b>Pit location status:</b> {{ pit_validation.pit_location }} <br />
        </div>
        
      </div>       
    </div>
    <div *ngIf="update_pit">
          <div class="form-group row">        
            <div class="form-group col-md-6">
              <label for="ada" class="lable-css">Enter Pit Size:</label>
              <input type="text" id="pit_size" formControlName="pit_size" name="pit_size" placeholder="Enter PIT Size" required (change)="pitSizeOnChange($event)" />
            </div>
            <button (click)="pitSizeChange()">Update Pit Size</button>
          </div>        
    </div>
    <div *ngIf="show_distance">
        <app-table                 
                table_title="selectBjl" 
                [inputData]="inputData"
                (appItemEvent)="receiveTableEventStructure($event)" >
        </app-table>
    </div>

    
    <button (click)="skipLocations()" style="float: right;">Skip Unselected Loc</button>
</div>



<div *ngIf="smp_connectivity_flag">
  <app-smp-connectivity-n2p
    [inputData] = "tableData"
  ></app-smp-connectivity-n2p>
</div>
<div *ngIf="trench_creation">
  
    <div class="form-group row">        
        <div class="form-group col-md-6">
          <label for="a_pit" class="lable-css">Enter A Pit:</label>
          <input type="text" id="a_pit" formControlName="a_pit" name="a_pit" placeholder="Enter A PIT" required (change)="updateVal($event,'a_pit')" />
        </div>
        <div class="form-group col-md-6">
          <label for="z_pit" class="lable-css">Enter Z Pit:</label>
          <input type="text" id="z_pit" formControlName="z_pit" name="z_pit" placeholder="Enter z PIT" required (change)="updateVal($event,'z_pit')" />
        </div>
    </div>
    <div class="form-group row">   
        <div class="form-group col-md-6">
          <label for="no_of_pits" class="lable-css">Enter No. of Pits:</label>
          <input type="text" id="no_of_pits" formControlName="no_of_pits" name="no_of_pits" placeholder="Enter No. of Pits" required (change)="updateVal($event,'no_of_pits')" />
        </div>
        <div class="form-group col-md-6">
          <button type="submit" (click)="onSubmit()"> Submit </button>
        </div>
    </div> 

</div>

<div *ngIf="bjl_flag">
  <app-select-bjl-n2p
    [inputData]="tableData"
  ></app-select-bjl-n2p>
</div>

<!-- spinner Component Called-->
<div *ngIf="isLoading">
  <ngx-spinner type = "ball-scale-multiple"></ngx-spinner> 
</div>

